import { useCallback } from 'react'
import cookies from 'utilities/cookie'
import { baseHttpRequest } from 'views/CustomerFacingDisplay/utils/cfdHttpRequest'
import cfdToast from 'views/CustomerFacingDisplay/utils/cfdToast'
import {
    CLOUD_API,
    LOCATION_TENANT_IDENTIFIER_ID,
    COMPANY_TENANT_IDENTIFIER_ID,
    webVersion,
    ClientVersion,
} from 'views/CustomerFacingDisplay/utils/getEnv'
import { COOKIES_TOKEN } from 'views/CustomerFacingDisplay/utils/localStorageKey'
interface IConfig {
    showErrorToast?: boolean
    showSuccessToast?: boolean
    errorMessage?: string
    successMessage?: string
}
const posRequest = () => {
    const instance = baseHttpRequest(CLOUD_API)
    instance.defaults.headers.common[
        'LocationTenantIdentifierID'
    ] = LOCATION_TENANT_IDENTIFIER_ID
    instance.defaults.headers.common[
        'CompanyTenantIdentifierID'
    ] = COMPANY_TENANT_IDENTIFIER_ID
    const token = cookies.get(COOKIES_TOKEN)
    if (token) instance.defaults.headers['Authorization'] = 'Bearer ' + token
    if (webVersion) {
        instance.defaults.headers[ClientVersion] = webVersion
    }
    return instance
}

const usePOSRequestCaller = () => {
    const get = useCallback(async <T>(url: string, config: IConfig = {}) => {
        const {
            showErrorToast = true,
            showSuccessToast = true,
            errorMessage = 'Loading Fail',
            successMessage = 'Load successful',
        } = config

        try {
            const res = await posRequest().get<T>(url)
            if (showSuccessToast) cfdToast.success(successMessage)
            return res
        } catch (error) {
            if (showErrorToast) cfdToast.error(errorMessage)
        }
    }, [])

    return { get }
}
export default usePOSRequestCaller
